// src/components/PublicRoute.js
import React from 'react';
import { useAuth } from '../context/AuthContext';
import { Navigate, Outlet } from 'react-router-dom';

function PublicRoute() {
  const { currentUser, userData, loading } = useAuth(); // Agregamos userData

  if (loading) {
    // Muestra una pantalla de carga mientras AuthContext verifica
    return <div className="form-container"><p>Cargando...</p></div>;
  }

  if (currentUser) {
    // IMPORTANTE: Esperar a que exista userData para decidir
    if (userData) {
      if ((userData.rol === 'masteruser' || userData.rol === 'superuser') && (!userData.condominioId || userData.condominioId === 'GLOBAL')) {
          // Si es Staff corporativo / Master User, va al portal maestro.
          return <Navigate to="/superuser/master-portal" replace />;
      }
      return <Navigate to="/app" replace />;
    } else {
      // Mientras AuthContext obtiene los datos de firestore, mostramos carga
      return <div className="form-container"><p>Validando permisos...</p></div>;
    }
  }

  // Si no hay usuario, muestra la ruta pública (LoginScreen, RegistroScreen)
  return <Outlet />;
}

export default PublicRoute;